import { Injectable } from "@angular/core";

import {
  ConnectionMonitorAuditTableDefinitionFactory,
  ProfilePromiseActionService,
  SystemConfigPromiseService,
  SystemMonitorLookupService,
} from "shared/cubiq-services";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { GoldenLayoutService } from "../golden-layout/golden-layout-service";
import { BfxUserProfileService } from "../bfx-common/services/bfx-user-profile.service";
import {
  BfxConnectionMonitorConnectionsService,
  BfxConnectionMonitorConnectionEvent,
} from "./bfx-connection-monitor-connections.service";
import { SystemMonitorEventImpl } from "shared/cubiq-model-multi-asset";
import { SYSMON_EVENT_ID } from "shared/cubiq-services/lookup/model/impl/SystemMonitorLookup.constants";

@Injectable()
export class BfxConnectionMonitorAuditService extends BfxConnectionMonitorConnectionsService {
  constructor(
    public lookupService: SystemMonitorLookupService,
    public tableDefinitionFactory: ConnectionMonitorAuditTableDefinitionFactory,
    public profileActionService: ProfilePromiseActionService,
    public goldenLayoutService: GoldenLayoutService,
    protected userProfileService: BfxUserProfileService,
    protected systemConfigService: SystemConfigPromiseService,
  ) {
    super(
      lookupService,
      tableDefinitionFactory,
      profileActionService,
      goldenLayoutService,
      userProfileService,
      systemConfigService,
    );
    this.lookupService.getClearedSubject().subscribe(this.processClearedEvent.bind(this));
  }

  protected getAllRecords(): SystemMonitorEventImpl[] {
    return this.lookupService.getAll();
  }

  protected transformEvent(
    systemMonitorEvent: SystemMonitorEventImpl,
  ): BfxConnectionMonitorConnectionEvent {
    let event: BfxConnectionMonitorConnectionEvent = super.transformEvent(systemMonitorEvent);

    event.eventId = systemMonitorEvent.dataMap.get(SYSMON_EVENT_ID);

    return event;
  }

  protected processClearedEvent(event: SystemMonitorEventImpl): void {
    let eventId: string = event.dataMap.get(SYSMON_EVENT_ID);
    if (eventId != null) {
      this.onDeleteEvent(eventId);
    }
  }
}
